<div class="modal-header">
	<button class="button white pull-left" data-dismiss="modal">{{t "common.cancel"}}</button>
	<button class="button green pull-right save-button">{{t "common.save"}}</button>
	<h4>{{t "stories.editStory"}}</h4>
</div>
<div class="modal-body">
	<div class="form-horizontal stormql-controls"></div>
</div>
